module.exports = __webpack_public_path__ + "img/slide-4.ae139e45.webp";